export function StubPage({ title }: { title: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 text-center">
      <div className="text-xl font-semibold">{title}</div>
      <p className="max-w-sm text-sm text-muted-fg">Этот раздел в разработке. Скоро здесь появится функциональность.</p>
    </div>
  );
}
